import React from "react";
import styled from "@emotion/styled";
import { specialGuarantees } from "discription";

interface typeInfoContent {
  code: string;
  type: string;
  description: any[];
  specialAmount: string[];
}

interface GuaranteeTableProps {
  contents: any;
  planType?: string;
}

const GuaranteeTable: React.FC<GuaranteeTableProps> = ({
  contents,
  planType
}) => (
  <TableDiff>
    <div className="table">
      <div className="tr">
        <div className="thRoot first">담보명</div>
        <div className="thRoot">담보상세내용</div>
        {contents
          .filter((plan: typeInfoContent) => plan.code !== "")
          .map((item: typeInfoContent, k: number) => {
            if (item.code === planType) {
              return (
                <div className="thRoot selected" key={`thRoot${k}`}>
                  {item.type}
                </div>
              );
            } else {
              return (
                <div className="thRoot" key={`thRoot${k}`}>
                  {item.type}
                </div>
              );
            }
          })}
      </div>
      {specialGuarantees.v2.data.map((guaranteeItem: any, i: number) => (
        <div className="tr" key={`tr${i}`}>
          <div className="th">{guaranteeItem.title}</div>
          <div className="td td2">{guaranteeItem.desc}</div>
          {contents
            .filter((planType: typeInfoContent) => planType.code !== "")
            .map((item: typeInfoContent, j: number) => {
              if (item.code === planType) {
                return (
                  <div className="td center selected" key={`td${j}`}>
                    {item.specialAmount[i]}
                  </div>
                );
              } else {
                return (
                  <div className="td center" key={`td${j}`}>
                    {item.specialAmount[i]}
                  </div>
                );
              }
            })}
        </div>
      ))}
    </div>
  </TableDiff>
);

export default GuaranteeTable;

const TableDiff = styled.div`
  .table {
    display: table;
    word-break: break-all;
    color: ${props => props.theme.table.colorBorder};

    > .tr:last-of-type {
      .th,
      .td {
        border-bottom: 1px solid ${props => props.theme.table.colorBorder};
      }
      .selected {
        border-bottom-color: ${props => props.theme.colors.primary};
      }
    }
  }

  .tr {
    display: table-row;
  }

  .thRoot {
    display: table-cell;
    padding: 13px 10px 12px;
    border-top: 1px solid ${props => props.theme.table.colorBorder};
    border-left: 1px solid ${props => props.theme.table.colorBorderInner};
    font-weight: 600;
    text-align: center;

    &.first {
      border-left: 0;
    }

    &.selected {
      border-top-color: ${props => props.theme.colors.primary};
      border-left-color: ${props => props.theme.colors.primary};
      & + .thRoot {
        border-left-color: ${props => props.theme.colors.primary};
      }
    }

    &.selected:last-of-type {
      border-right: 1px solid ${props => props.theme.colors.primary};
    }
  }

  .th,
  .td {
    display: table-cell;
    padding: 10px 11px 9px;
    border-top: 1px solid ${props => props.theme.table.colorBorderInner};
    vertical-align: middle;
    letter-spacing: -0.3;
  }

  .th {
    width: 23%;
    text-align: left;
    word-break: keep-all;
  }

  .td {
    width: 11%;
    border-left: 1px solid ${props => props.theme.table.colorBorderInner};
    font-size: ${props => props.theme.text.fontSmall};

    &.selected {
      border-left-color: ${props => props.theme.colors.primary};

      & + .td {
        border-left-color: ${props => props.theme.colors.primary};
      }
    }

    &.selected:last-of-type {
      border-right: 1px solid ${props => props.theme.colors.primary};
    }

    &.center {
      text-align: center;
    }
  }

  .td2 {
    width: 44%;
  }
`;
